import { render, staticRenderFns } from "./PopupTipSuccess.vue?vue&type=template&id=36bcb148&scoped=true&"
import script from "./PopupTipSuccess.vue?vue&type=script&lang=ts&"
export * from "./PopupTipSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PopupTipSuccess.vue?vue&type=style&index=0&id=36bcb148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcb148",
  null
  
)

export default component.exports